export class WebSocketError extends Error {
    constructor(message, code, response) {
        super(message);
        this.code = code;
        this.response = response;
        console.error(this, JSON.stringify(Object.assign({}, this), null, 2));
    }
}
